// extracted by mini-css-extract-plugin
export var errorIcon = "_o5-1";
export var nameLogo = "_o5-0";